import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useResource } from "@rest-hooks/core";
import { IntegrationClientResource } from "@ploy-lib/rest-resources";
import { DployAutocomplete } from "@ploy-ui/form-fields";
import { FormattedMessage } from "react-intl";
export const IntegrationSelector = (props) => {
    const { integrationId, vendorId, setIntegration } = props;
    const integrations = (useResource(IntegrationClientResource.list(), vendorId
        ? {
            vendorId: vendorId
        }
        : {}) || []);
    const [selected, setSelected] = useState(integrations.find(x => x.integrationClientId === integrationId));
    return (_jsxs(_Fragment, { children: [_jsx(FormattedMessage, { id: "integration.select.integration", description: "Show applications from integration", defaultMessage: "Vis saker fra integrasjon:" }), _jsx(DployAutocomplete, { style: { width: 300 }, value: selected, items: integrations, onChange: (event, value) => {
                    setSelected(value ?? undefined);
                    setIntegration(value);
                }, fullWidth: true, getItemLabel: item => item.code, disableClearable: true })] }));
};
//# sourceMappingURL=IntegrationSelector.js.map